"use client";
import React, { useState, createContext, useEffect } from "react";

const debounce = (func: Function, delay: number) => {
  let timer: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const OnePageCheckoutContext = createContext<{
  open?: boolean;
  toggleOpen?: () => void;
}>({});

const OnePageCheckoutProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const [is_desktop, setIsDesktop] = useState<boolean>(false);

  useEffect(() => {
    if (window) {
      setIsDesktop(!(window != undefined && window.innerWidth <= 900));
      const handleResize = debounce(() => {
        setIsDesktop(window.innerWidth >= 900);
      }, 200); // 200ms delay

      window.addEventListener("resize", handleResize);

      // Cleanup
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);

  const toggleOpen = () => {
    console.log("toggleOpen");
    setOpen(!open);
  };

  return (
    <OnePageCheckoutContext.Provider
      value={{ open: open || is_desktop, toggleOpen }}
    >
      {children}
    </OnePageCheckoutContext.Provider>
  );
};

export default OnePageCheckoutProvider;
